import { PartnerPhoto, SmartphotoPhoto, StoreType } from "../../services/storageService";
import { showLoadingDialog } from "../popups/loading-dialog";

export interface PhotoImport {
	selection: SmartphotoPhoto[] | PartnerPhoto[] | FileList;
	storeType: StoreType;
}

export function sendImportPhotosPopUpErrorCreatorEvent(bc: BroadcastChannel) {
	// Todo: remove when CRE-5952 finishes migrating to using postMessage
	window.parent.postMessage(
		{ command: "ImportPhotosPopUpError", detail: { errorCode: "unableToConnectToPartner" } },
		"*",
	);
	bc.postMessage({
		command: "ImportPhotosPopUpError",
		detail: {
			errorCode: "unableToConnectToPartner",
		},
	});
}

export function sendImportPhotosFinishedCreatorEvent(bc: BroadcastChannel, data: PhotoImport | null) {
	// Todo: remove when CRE-5952 finishes migrating to using postMessage
	window.parent.document.dispatchEvent(new CustomEvent("importPhotosFinished", { detail: data }));
	bc.postMessage({ command: "ImportPhotosFinished", detail: data });
	window.parent.postMessage({ command: "ImportPhotosFinished", detail: data }, "*");
}

export function addOnCloseIconCreatorEvent(bc: BroadcastChannel, closeIcon: HTMLElement) {
	closeIcon.addEventListener("click", (_) => {
		// Todo: remove when CRE-5952 finishes migrating to using postMessage
		window.parent.postMessage({ command: "CloseImportPhotosPopUp" }, "*");
		bc.postMessage({ command: "CloseImportPhotosPopUp" });
	});
}

export function sendClosePartnerPopUpCreatorEvent(bc: BroadcastChannel) {
	// Todo: remove when CRE-5952 finishes migrating to using postMessage
	window.parent.postMessage({ command: "ImportPhotosClosed" }, "*");
	bc.postMessage({ command: "ImportPhotosClosed" });
}

export async function addOnBackIconCreatorEvent(bc: BroadcastChannel, backIcon: HTMLElement) {
	backIcon.addEventListener("click", function () {
		const url = backIcon.dataset.url;
		if (url) {
			window.location.href = window.location.origin + url;
			showLoadingDialog(Promise.resolve(), 0, 10000);
		}
	});
}
